import pkg from '../package.json';
export var version = pkg.version;
export { compile } from './compile/compile';
export { normalize } from './normalize';
export * from './util';